import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Alert, Icon } from 'components';
import { Covid19StateType } from '../../types';

type CovidBannerProps = {
  userType: 'agent' | 'coop' | 'client' | 'rets';
  covid19State: Covid19StateType;
};

const CovidBanner: React.FC<CovidBannerProps> = ({
  userType,
  covid19State,
}) => {
  const [visible, setVisible] = React.useState(true);

  useEffect(() => {
    setVisible(covid19State.status === 'signatureRequired');
  }, [covid19State.status]);

  return (
    <>
      <AlertContainer visible={visible}>
        <StyledAlert
          data-cy="covid-banner"
          showIcon
          type="warning"
          message={
            ['agent', 'client'].includes(userType)
              ? 'COVID-19 waivers have not been signed by the showing agent'
              : 'COVID-19 waivers must be signed before showing a listing'
          }
          action={covid19State.action}
          icon={
            <Icon type="antdExclamationCircle" width={15} color="orange6" />
          }
        />
      </AlertContainer>
    </>
  );
};

const AlertContainer = styled.div<{ visible: boolean }>`
  ${props => (props.visible === false ? 'display: none' : '')};
`;

const StyledAlert = styled(Alert)`
  border: 1px solid #ffd591;
`;

export default CovidBanner;
